import NumberInput from '@customer/components/inputs/number-input/NumberInput';
import useNumberInput from '@customer/components/inputs/number-input/useNumberInput';
import { useAppSelector } from '@customer/store/hooks';
import { NumberFilters } from '@customer/store/slices/filtersSlice';
import { ReactElement, Ref } from 'react';
import { ActionCreatorWithPayload } from '@reduxjs/toolkit';

interface NumberFilterProps {
  filterName: keyof NumberFilters;
  label: ReactElement | string;
  tooltipLabel?: string;
  elementRef: Ref<HTMLVdsBasicInputElement>;
  action: ActionCreatorWithPayload<number | null>;
  placeholder?: string;
}

export const NumberFilter = ({
  filterName,
  label,
  tooltipLabel,
  elementRef,
  action,
  placeholder,
}: NumberFilterProps) => {
  const value = useAppSelector(state => state.filters.draft[filterName]);

  // Don't include the ref, this needs to be created at the parent level.
  const [, onChange] = useNumberInput(action);

  return (
    <NumberInput
      uid={filterName}
      label={label}
      tooltipLabel={tooltipLabel}
      elementRef={elementRef}
      placeholder={placeholder ?? ''}
      onChange={onChange}
      value={value}
    />
  );
};

export default NumberFilter;
